import { CoreModel } from '../core/core.model';
export class ListModel extends CoreModel {
/**
 * It is title for the Component.
 */
title?: string;
/**
 * Property for selectable
 */
selectable?: boolean;
/**
 * Property to show checkbox on list items
 */
withCheckbox?: boolean;
/**
 * It is icon constructor, which take values from List Component and create List Model object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ListModel_tsickle_Closure_declarations() {
/**
 * It is title for the Component.
 * @type {?}
 */
ListModel.prototype.title;
/**
 * Property for selectable
 * @type {?}
 */
ListModel.prototype.selectable;
/**
 * Property to show checkbox on list items
 * @type {?}
 */
ListModel.prototype.withCheckbox;
}

